/**
 * Constants
 */

exports.levelType = [
  { key: "elem", text: "Elementary", value: "ELEM" },
  { key: "elemp", text: "Elementary - Primary", value: "ELEMP" },
  { key: "elemi", text: "Elementary - Intermediate", value: "ELEMI" },
  { key: "hs", text: "High School", value: "HS" },
  { key: "jrhs", text: "Junior High School", value: "JHS" },
  { key: "srhshumss", text: "Senior High School - HUMSS", value: "SHSHUMSS" },
  { key: "srhsstem", text: "Senior High School - STEM", value: "SHSSTEM" },
  { key: "srhsabm", text: "Senior High School - ABM", value: "SHSABM" },
  { key: "na", text: "N/A", value: "NA" },
];

exports.gradeLevel = [
  { key: "1", text: "Grade 1", value: "Grade 1" },
  { key: "2", text: "Grade 2", value: "Grade 2" },
  { key: "3", text: "Grade 3", value: "Grade 3" },
  { key: "4", text: "Grade 4", value: "Grade 4" },
  { key: "5", text: "Grade 5", value: "Grade 5" },
  { key: "6", text: "Grade 6", value: "Grade 6" },
  { key: "7", text: "Grade 7", value: "Grade 7" },
  { key: "8", text: "Grade 8", value: "Grade 8" },
  { key: "9", text: "Grade 9", value: "Grade 9" },
  { key: "10", text: "Grade 10", value: "Grade 10" },
  { key: "11", text: "Grade 11 - HUMMS", value: "Grade 11 - HUMMS" },
  { key: "12", text: "Grade 11 - STEM", value: "Grade 11 - STEM" },
  { key: "13", text: "Grade 11 - ABM", value: "Grade 11 - ABM" },
  { key: "14", text: "Grade 12 - HUMMS", value: "Grade 12 - HUMMS" },
  { key: "15", text: "Grade 12 - STEM", value: "Grade 12 - STEM" },
  { key: "16", text: "Grade 12 - ABM", value: "Grade 12 - ABM" },
];

exports.breakdownGradeLevel = [
  { key: "n", text: "Nursery", value: "Nursery" },
  { key: "pk", text: "Pre-Kinder", value: "Pre-Kinder" },
  { key: "k", text: "Kinder", value: "Kinder" },
  { key: "1", text: "Grade 1", value: "Grade 1" },
  { key: "2", text: "Grade 2", value: "Grade 2" },
  { key: "3", text: "Grade 3", value: "Grade 3" },
  { key: "4", text: "Grade 4", value: "Grade 4" },
  { key: "5", text: "Grade 5", value: "Grade 5" },
  { key: "6", text: "Grade 6", value: "Grade 6" },
  { key: "7", text: "Grade 7", value: "Grade 7" },
  { key: "8", text: "Grade 8", value: "Grade 8" },
  { key: "9", text: "Grade 9", value: "Grade 9" },
  { key: "10", text: "Grade 10", value: "Grade 10" },
  { key: "11", text: "Grade 11", value: "Grade 11" },
  { key: "12", text: "Grade 12", value: "Grade 12" },
];

exports.quarter = [
  { key: "1", text: "1st Quarter", value: 1 },
  { key: "2", text: "2nd Quarter", value: 2 },
  { key: "3", text: "3rd Quarter", value: 3 },
  { key: "4", text: "4th Quarter", value: 4 },
];

// Quarter configuration constants
exports.quarterConfig = {
  // Month ranges for each quarter (1-12)
  QUARTER_MONTHS: {
    1: { start: 7, end: 9, name: "July - September" },
    2: { start: 10, end: 1, name: "October - January", spanYear: true },
    3: { start: 2, end: 3, name: "February - March" },
    4: { start: 4, end: 6, name: "April - June" },
  },
  
  // Database field mappings
  DB_FIELDS: {
    grades: {
      1: "firstQuarter",
      2: "secondQuarter", 
      3: "thirdQuarter",
      4: "fourthQuarter",
    },
    conducts: {
      1: "firstQuarter",
      2: "secondQuarter",
      3: "thirdQuarter", 
      4: "fourthQuarter",
    },
  },
  
  // Default quarter settings
  DEFAULT_QUARTER: 1,
  TOTAL_QUARTERS: 4,
  
  // School year settings
  SCHOOL_YEAR_START_MONTH: 7, // July
  SCHOOL_YEAR_END_MONTH: 6,   // June
};

exports.paymentSchedule = [
  { key: "1", text: "Full Cash Basis", value: "Full Cash Basis" },
  { key: "2", text: "Semi-Annual", value: "Semi-Annual" },
  { key: "3", text: "Quarterly", value: "Quarterly" },
  { key: "4", text: "Monthly Basis", value: "Monthly Basis" },
  { key: "5", text: "Others", value: "Others" },
];

exports.subjectCategory = [
  { key: "1", text: "Mother Tongue", value: "Mother Tongue" },
  { key: "2", text: "English", value: "English" },
  { key: "3", text: "Filipino", value: "Filipino" },
  { key: "4", text: "Mathematics", value: "Mathematics" },
  { key: "5", text: "Science", value: "Science" },
  { key: "6", text: "Araling Panlipunan", value: "Araling Panlipunan" },
  {
    key: "7",
    text: "Technology & Livelihood Education (TLE)",
    value: "Technology & Livelihood Education (TLE)",
  },
  { key: "8", text: "Music", value: "Music" },
  { key: "9", text: "Arts", value: "Arts" },
  { key: "10", text: "Physical Education", value: "Physical Education" },
  { key: "11", text: "Health", value: "Health" },
  { key: "12", text: "Computer Education", value: "Computer Education" },
  {
    key: "13",
    text: "Edukasyon sa Pagpapakatao (ESP)",
    value: "Edukasyon sa Pagpapakatao (ESP)",
  },
  {
    key: "14",
    text: "Edukasyong Pantahanan at Pangkabuhayan (EPP)",
    value: "Edukasyong Pantahanan at Pangkabuhayan (EPP)",
  },
  { key: "15", text: "Values", value: "Values" },
  { key: "16", text: "Elective", value: "Elective" },
  { key: "17", text: "Extra-Curricular", value: "Extra-Curricular" },
  { key: "18", text: "Oral Communication", value: "OC" },
  { key: "19", text: "Reading and Writing Skills", value: "RWS" },
  {
    key: "20",
    text: "Komunikasyon at Pananaliksik sa Wika at Kulturang Pilipino",
    value: "KOM",
  },
  {
    key: "21",
    text: "Pagbasa at Pagsusuri ng Iba't Ibang Teksto Tungo sa Pananaliksik",
    value: "PAGBASA",
  },
  {
    key: "22",
    text: "21st Century Literature from the Philippines and the World",
    value: "21LIT",
  },
  {
    key: "23",
    text: "Contemporary Philippine Arts from the Regions",
    value: "CPAR",
  },
  { key: "24", text: "Media and Information Literacy", value: "MIL" },
  { key: "25", text: "General Mathematics", value: "GM" },
  { key: "26", text: "Statistics and Probability", value: "SP" },
  { key: "27", text: "Earth and Life Science", value: "ELS" },
  { key: "28", text: "Physical Science", value: "PS" },
  {
    key: "29",
    text: "Introduction to the Philosophy of the Human Person",
    value: "IPHS",
  },
  { key: "30", text: "Physical Education and Health", value: "PEH" },
  { key: "31", text: "Personal Development", value: "PERDEV" },
  {
    key: "32",
    text: "Understanding Culture, Society and Politics",
    value: "UCSP",
  },
  { key: "33", text: "Earth Science", value: "ES" },
  { key: "34", text: "Disaster Readiness and Risk Reduction", value: "DRRR" },
  { key: "35", text: "Empowerment Technologies", value: "EMPTECH" },
  { key: "36", text: "Filipino sa Piling Larangan", value: "FPL" },
  { key: "37", text: "Practical Research 1", value: "PR1" },
  { key: "38", text: "Practical Research 2", value: "PR2" },
  {
    key: "39",
    text: "English for Academic and Professional Purposes",
    value: "EAPP",
  },
  { key: "40", text: "Entrepreneurship", value: "ENTREP" },
  { key: "41", text: "Inquiries, Investigations and Immersions", value: "III" },
  { key: "42", text: "Pre-Calculus", value: "PRECAL" },
  { key: "43", text: "Basic Calculus", value: "BCAL" },
  { key: "44", text: "General Biology 1", value: "BIO1" },
  { key: "45", text: "General Biology 2", value: "BIO2" },
  { key: "46", text: "General Chemistry 1", value: "CHEM1" },
  { key: "47", text: "General Chemistry 2", value: "CHEM2" },
  { key: "48", text: "General Physics 1", value: "PHY1" },
  { key: "49", text: "General Physics 2", value: "PHY2" },
  { key: "50", text: "Work Immersion", value: "WI" },
  { key: "51", text: "Creative Writing", value: "CW" },
  {
    key: "52",
    text: "Introduction to World Religions and Belief Systems",
    value: "IWRBS",
  },
  { key: "53", text: "Creative Non-Fiction", value: "CNF" },
  {
    key: "54",
    text: "Trends, Networks, and Critical Thinking in the 21st Century Culture",
    value: "TRENDS",
  },
  { key: "55", text: "Philippine Politics and Governance", value: "PPG" },
  {
    key: "56",
    text: "Community Engagement, Solidarity, and Citizenship",
    value: "CESC",
  },
  {
    key: "57",
    text: "Disciplines and Ideas in the Social Sciences",
    value: "DISS",
  },
  {
    key: "58",
    text: "Disciplines and Ideas in the Applied Social Sciences",
    value: "DIASS",
  },
  { key: "59", text: "Mother Tongue/ Filipino", value: "MTFilipino" },
  { key: "60", text: "Science/ English", value: "SciEnglish" },
  { key: "61", text: "Capstone Project", value: "CapstoneProject" },
  { key: "62", text: "Culminating Activity", value: "CulminatingActivity" },
  { key: "63", text: "Organization and Management", value: "ORGMGT" },
  { key: "64", text: "Business Math", value: "BUSMATH" },
  {
    key: "65",
    text: "Fundamentals of Accountancy, Business and Management 1",
    value: "FABM1",
  },
  { key: "66", text: "Principles of Marketing", value: "PRINMARKET" },

  //start of updates in subj
  //grade 1
  { key: "67", text: "Good Manners and Right Conduct", value: "GMRC" },
  { key: "68", text: "Language", value: "Language" },
  { key: "69", text: "Makabansa", value: "Makabansa" },
  { key: "70", text: "Reading and Literacy", value: "Reading and Literacy" },
  //end updates for g1

  //grade 4
  { key: "71", text: "Music and Arts", value: "Music and Arts" },
  { key: "72", text: "PE and Health", value: "PE and Health" },
  //end updates for g4
  // ABM 12 Subjects
  {
    key: "73",
    text: "Fundamentals of Accountancy Business and Management 2",
    value: "FABM2",
  },
  { key: "74", text: "Applied Economics", value: "APPECON" },
  { key: "75", text: "Business Finance", value: "BUSFIN" },
  {
    key: "76",
    text: "Business Ethics and Social Responsibility",
    value: "BESR",
  },
  // end if ABM 12 subjects
];

exports.subjectElemP = [
  // { key: '1', text: 'Mother Tongue/ Filipino', value: 'MTFilipino' },
  { key: "1", text: "Filipino", value: "Filipino" },
  { key: "2", text: "English", value: "English" },
  { key: "4", text: "Mathematics", value: "Mathematics" },
  { key: "3", text: "Science", value: "Science" },
  { key: "5", text: "Science/ English", value: "SciEnglish" },
  { key: "6", text: "Araling Panlipunan", value: "Araling Panlipunan" },
  { key: "7", text: "MAPEH", value: "MAPEH" },
  { key: "8", text: "Music", value: "Music" },
  { key: "9", text: "Arts", value: "Arts" },
  { key: "10", text: "Physical Education", value: "Physical Education" },
  { key: "11", text: "Health", value: "Health" },
  {
    key: "13",
    text: "Edukasyon sa Pagpapakatao (ESP)",
    value: "Edukasyon sa Pagpapakatao (ESP)",
  },
];

exports.subjectGrade1 = [
  // { key: '1', text: 'Mother Tongue/ Filipino', value: 'MTFilipino' },
  // { key: '2', text: 'English', value: 'English' },
  // { key: '3', text: 'Science', value: 'Science' },
  // { key: '5', text: 'Science/ English', value: 'SciEnglish' },
  // { key: '6', text: 'Araling Panlipunan', value: 'Araling Panlipunan' },
  // { key: '7', text: 'MAPEH', value: 'MAPEH' },
  // { key: '8', text: 'Music', value: 'Music' },
  // { key: '9', text: 'Arts', value: 'Arts' },
  // { key: '10', text: 'Physical Education', value: 'Physical Education' },
  // { key: '11', text: 'Health', value: 'Health' },
  // { key: '13', text: 'Edukasyon sa Pagpapakatao (ESP)', value: 'Edukasyon sa Pagpapakatao (ESP)' },
  { key: "68", text: "Language", value: "Language" },
  { key: "70", text: "Reading and Literacy", value: "Reading and Literacy" },
  { key: "4", text: "Mathematics", value: "Mathematics" },
  { key: "69", text: "Makabansa", value: "Makabansa" },
  { key: "67", text: "Good Manners and Right Conduct", value: "GMRC" },
];

exports.subjectElemI = [
  { key: "2", text: "English", value: "English" },
  { key: "3", text: "Filipino", value: "Filipino" },
  { key: "4", text: "Mathematics", value: "Mathematics" },
  { key: "5", text: "Science", value: "Science" },
  { key: "6", text: "Araling Panlipunan", value: "Araling Panlipunan" },
  { key: "7", text: "MAPEH", value: "MAPEH" },
  { key: "9", text: "Music", value: "Music" },
  { key: "10", text: "Arts", value: "Arts" },
  { key: "11", text: "Physical Education", value: "Physical Education" },
  { key: "12", text: "Health", value: "Health" },
  {
    key: "13",
    text: "Edukasyon sa Pagpapakatao (ESP)",
    value: "Edukasyon sa Pagpapakatao (ESP)",
  },
  {
    key: "14",
    text: "Edukasyong Pantahanan at Pangkabuhayan (EPP)",
    value: "Edukasyong Pantahanan at Pangkabuhayan (EPP)",
  },
];

exports.subjectGrade4 = [
  { key: "2", text: "English", value: "English" },
  { key: "3", text: "Filipino", value: "Filipino" },
  { key: "4", text: "Mathematics", value: "Mathematics" },
  { key: "5", text: "Science", value: "Science" },
  { key: "6", text: "Araling Panlipunan", value: "Araling Panlipunan" },
  { key: "7", text: "MAPEH", value: "MAPEH" },
  { key: "71", text: "Music and Arts", value: "Music and Arts" },
  { key: "72", text: "Physical Education and Health", value: "PEH" },
  { key: "15", text: "Values", value: "Values" },
  {
    key: "14",
    text: "Edukasyong Pantahanan at Pangkabuhayan (EPP)",
    value: "Edukasyong Pantahanan at Pangkabuhayan (EPP)",
  },
];

exports.subjectJHS = [
  { key: "2", text: "English", value: "English" },
  { key: "3", text: "Filipino", value: "Filipino" },
  { key: "4", text: "Mathematics", value: "Mathematics" },
  { key: "5", text: "Science", value: "Science" },
  { key: "6", text: "Araling Panlipunan", value: "Araling Panlipunan" },
  {
    key: "7",
    text: "Technology & Livelihood Education (TLE)",
    value: "Technology & Livelihood Education (TLE)",
  },
  { key: "8", text: "MAPEH", value: "MAPEH" },
  { key: "9", text: "Music", value: "Music" },
  { key: "10", text: "Arts", value: "Arts" },
  { key: "11", text: "Physical Education", value: "Physical Education" },
  { key: "12", text: "Health", value: "Health" },
  {
    key: "14",
    text: "Edukasyon sa Pagpapakatao (ESP)",
    value: "Edukasyon sa Pagpapakatao (ESP)",
  },
];

exports.subjectGrade7 = [
  { key: "2", text: "English", value: "English" },
  { key: "3", text: "Filipino", value: "Filipino" },
  { key: "4", text: "Mathematics", value: "Mathematics" },
  { key: "5", text: "Science", value: "Science" },
  { key: "6", text: "Araling Panlipunan", value: "Araling Panlipunan" },
  {
    key: "7",
    text: "Technology & Livelihood Education (TLE)",
    value: "Technology & Livelihood Education (TLE)",
  },
  { key: "8", text: "MAPEH", value: "MAPEH" },
  { key: "71", text: "Music and Arts", value: "Music and Arts" },
  { key: "72", text: "Physical Education and Health", value: "PEH" },
  { key: "15", text: "Values", value: "Values" },
];

exports.subjectHUMSSSHS12 = {
  Core1: [
    {
      key: "29",
      text: "Introduction to the Philosophy of the Human Person",
      value: "IPHS",
    },
    {
      key: "23",
      text: "Contemporary Philippine Arts from the Regions",
      value: "CPAR",
    },
    {
      key: "32",
      text: "Understanding Culture, Society and Politics",
      value: "UCSP",
    },
    { key: "30", text: "Physical Education and Health", value: "PEH" },
  ],
  AppliedAndSpecializedSubjects1: [
    { key: "38", text: "Practical Research 2", value: "PR2" },
    {
      key: "39",
      text: "English for Academic and Professional Purposes",
      value: "EAPP",
    },
    {
      key: "56",
      text: "Community Engagement, Solidarity, and Citizenship",
      value: "CESC",
    },
    { key: "51", text: "Creative Writing", value: "CW" },
  ],
  Core2: [
    { key: "24", text: "Media and Information Literacy", value: "MIL" },
    { key: "30", text: "Physical Education and Health", value: "PEH" },
  ],
  AppliedAndSpecializedSubjects2: [
    {
      key: "41",
      text: "Inquiries, Investigations and Immersions",
      value: "III",
    },
    {
      key: "54",
      text: "Trends, Networks, and Critical Thinking in the 21st Century Culture",
      value: "TRENDS",
    },
    { key: "53", text: "Creative Non-Fiction", value: "CNF" },
    { key: "50", text: "Work Immersion", value: "WI" },
  ],
};

exports.subjectHUMSSSHS11 = {
  Core1: [
    { key: "18", text: "Oral Communication", value: "OC" },
    {
      key: "20",
      text: "Komunikasyon at Pananaliksik sa Wika at Kulturang Pilipino",
      value: "KOM",
    },
    { key: "25", text: "General Mathematics", value: "GM" },
    { key: "27", text: "Earth and Life Science", value: "ELS" },
    {
      key: "22",
      text: "21st Century Literature from the Philippines and the World",
      value: "21LIT",
    },
    { key: "30", text: "Physical Education and Health", value: "PEH" },
  ],
  AppliedAndSpecializedSubjects1: [
    { key: "35", text: "Empowerment Technologies", value: "EMPTECH" },
    // { key: "36", text: "Filipino sa Piling Larangan", value: "FPL" },
    { key: "55", text: "Philippine Politics and Governance", value: "PPG" },
    {
      key: "57",
      text: "Disciplines and Ideas in the Social Sciences",
      value: "DISS",
    },
  ],
  Core2: [
    { key: "19", text: "Reading and Writing Skills", value: "RWS" },
    {
      key: "21",
      text: "Pagbasa at Pagsusuri ng Iba't Ibang Teksto Tungo sa Pananaliksik",
      value: "PAGBASA",
    },
    { key: "26", text: "Statistics and Probability", value: "SP" },
    { key: "28", text: "Physical Science", value: "PS" },
    // { key: "31", text: "Personal Development", value: "PERDEV" },
    { key: "30", text: "Physical Education and Health", value: "PEH" },
  ],
  AppliedAndSpecializedSubjects2: [
    { key: "37", text: "Practical Research 1", value: "PR1" },
    { key: "40", text: "Entrepreneurship", value: "ENTREP" },
    {
      key: "52",
      text: "Introduction to World Religions and Belief Systems",
      value: "IWRBS",
    },
    {
      key: "58",
      text: "Disciplines and Ideas in the Applied Social Sciences",
      value: "DIASS",
    },
  ],
};

exports.subjectSTEMSHS11 = {
  Core1: [
    { key: "18", text: "Oral Communication", value: "OC" },
    {
      key: "20",
      text: "Komunikasyon at Pananaliksik sa Wika at Kulturang Pilipino",
      value: "KOM",
    },
    { key: "25", text: "General Mathematics", value: "GM" },
    { key: "33", text: "Earth Science", value: "ES" },
    {
      key: "22",
      text: "21st Century Literature from the Philippines and the World",
      value: "21LIT",
    },
    { key: "30", text: "Physical Education and Health", value: "PEH" },
  ],
  AppliedAndSpecializedSubjects1: [
    { key: "35", text: "Empowerment Technologies", value: "EMPTECH" },
    // { key: "36", text: "Filipino sa Piling Larangan", value: "FPL" },
    { key: "42", text: "Pre-Calculus", value: "PRECAL" },
    { key: "44", text: "General Biology 1", value: "BIO1" },
  ],
  Core2: [
    { key: "19", text: "Reading and Writing Skills", value: "RWS" },
    {
      key: "21",
      text: "Pagbasa at Pagsusuri ng Iba't Ibang Teksto Tungo sa Pananaliksik",
      value: "PAGBASA",
    },
    { key: "26", text: "Statistics and Probability", value: "SP" },
    { key: "34", text: "Disaster Readiness and Risk Reduction", value: "DRRR" },
    // { key: "31", text: "Personal Development", value: "PERDEV" },
    { key: "30", text: "Physical Education and Health", value: "PEH" },
  ],
  AppliedAndSpecializedSubjects2: [
    { key: "37", text: "Practical Research 1", value: "PR1" },
    { key: "40", text: "Entrepreneurship", value: "ENTREP" },
    { key: "43", text: "Basic Calculus", value: "BCAL" },
    { key: "45", text: "General Biology 2", value: "BIO2" },
  ],
};

exports.subjectSTEMSHS12 = {
  Core1: [
    {
      key: "29",
      text: "Introduction to the Philosophy of the Human Person",
      value: "IPHS",
    },
    {
      key: "23",
      text: "Contemporary Philippine Arts from the Regions",
      value: "CPAR",
    },
    {
      key: "32",
      text: "Understanding Culture, Society and Politics",
      value: "UCSP",
    },
    { key: "30", text: "Physical Education and Health", value: "PEH" },
  ],
  AppliedAndSpecializedSubjects1: [
    { key: "38", text: "Practical Research 2", value: "PR2" },
    {
      key: "39",
      text: "English for Academic and Professional Purposes",
      value: "EAPP",
    },
    { key: "48", text: "General Physics 1", value: "PHY1" },
    { key: "46", text: "General Chemistry 1", value: "CHEM1" },
  ],
  Core2: [
    { key: "24", text: "Media and Information Literacy", value: "MIL" },
    { key: "30", text: "Physical Education and Health", value: "PEH" },
  ],
  AppliedAndSpecializedSubjects2: [
    {
      key: "41",
      text: "Inquiries, Investigations and Immersions",
      value: "III",
    },
    { key: "49", text: "General Physics 2", value: "PHY2" },
    { key: "47", text: "General Chemistry 2", value: "CHEM2" },
    { key: "50", text: "Work Immersion", value: "WI" },
  ],
};

exports.subjectABMSHS11 = {
  Core1: [
    { key: "18", text: "Oral Communication", value: "OC" },
    {
      key: "20",
      text: "Komunikasyon at Pananaliksik sa Wika at Kulturang Pilipino",
      value: "KOM",
    },
    { key: "25", text: "General Mathematics", value: "GM" },
    { key: "27", text: "Earth and Life Science", value: "ELS" },
    {
      key: "22",
      text: "21st Century Literature from the Philippines and the World",
      value: "21LIT",
    },
    { key: "30", text: "Physical Education and Health", value: "PEH" },
  ],
  AppliedAndSpecializedSubjects1: [
    { key: "35", text: "Empowerment Technologies", value: "EMPTECH" },
    //  { key: "36", text: "Filipino sa Piling Larangan", value: "FPL" },
    { key: "63", text: "Organization and Management", value: "ORGMGT" },
    { key: "64", text: "Business Math", value: "BUSMATH" },
  ],
  Core2: [
    { key: "19", text: "Reading and Writing Skills", value: "RWS" },
    {
      key: "21",
      text: "Pagbasa at Pagsusuri ng Iba't Ibang Teksto Tungo sa Pananaliksik",
      value: "PAGBASA",
    },
    { key: "26", text: "Statistics and Probability", value: "SP" },
    { key: "28", text: "Physical Science", value: "PS" },
    // { key: "31", text: "Personal Development", value: "PERDEV" },
    { key: "30", text: "Physical Education and Health", value: "PEH" },
  ],
  AppliedAndSpecializedSubjects2: [
    { key: "37", text: "Practical Research 1", value: "PR1" },
    { key: "40", text: "Entrepreneurship", value: "ENTREP" },
    {
      key: "65",
      text: "Fundamentals of Accountancy, Business and Management 1",
      value: "FABM1",
    },
    { key: "66", text: "Principles of Marketing", value: "PRINMARKET" },
  ],
};

exports.subjectABMSHS12 = {
  Core1: [
    {
      key: "29",
      text: "Introduction to the Philosophy of the Human Person",
      value: "IPHS",
    },
    {
      key: "23",
      text: "Contemporary Philippine Arts from the Regions",
      value: "CPAR",
    },
    {
      key: "32",
      text: "Understanding Culture, Society and Politics",
      value: "UCSP",
    },
    { key: "30", text: "Physical Education and Health", value: "PEH" },
  ],
  AppliedAndSpecializedSubjects1: [
    { key: "38", text: "Practical Research 2", value: "PR2" },
    {
      key: "39",
      text: "English for Academic and Professional Purposes",
      value: "EAPP",
    },
    {
      key: "73",
      text: "Fundamentals of Accountancy Business and Management 2",
      value: "FABM2",
    },
    { key: "74", text: "Applied Economics", value: "APPECON" },
  ],
  Core2: [
    { key: "24", text: "Media and Information Literacy", value: "MIL" },
    { key: "30", text: "Physical Education and Health", value: "PEH" },
  ],
  AppliedAndSpecializedSubjects2: [
    {
      key: "41",
      text: "Inquiries, Investigations and Immersions",
      value: "III",
    },
    { key: "75", text: "Business Finance", value: "BUSFIN" },
    {
      key: "76",
      text: "Business Ethics and Social Responsibility",
      value: "BESR",
    },
    { key: "50", text: "Work Immersion", value: "WI" },
  ],
};

exports.paymentTypes = [
  { key: "ue", text: "Upon Enrollment", value: "Upon Enrollment" },
  { key: "res", text: "Reservation", value: "Reservation" },
  { key: "eb", text: "Enrollment Balance", value: "Enrollment Balance" },
  { key: "cob", text: "Carry Over Balance", value: "Carry Over Balance" },
  { key: "others", text: "Others", value: "Others" },
];

exports.breakdownOfFees = [
  {
    gradeLevel: "Nursery",
    tuition: "29,996",
    misc: "4,860",
    books: "3,000",
    total: "37,856",
    subsidy: "",
    grandTotal: "37,856",
  },
  {
    gradeLevel: "Pre-Kinder",
    tuition: "31,580",
    misc: "4,860",
    books: "3,000",
    total: "39,440",
    subsidy: "",
    grandTotal: "39,440",
  },
  {
    gradeLevel: "Kinder",
    tuition: "31,580",
    misc: "8,260",
    books: "3,000",
    total: "42,840",
    subsidy: "",
    grandTotal: "42,840",
  },
  {
    gradeLevel: "Grade 1",
    tuition: "35,948",
    misc: "10,477",
    books: "4,500",
    total: "50,926",
    subsidy: "",
    grandTotal: "50,926",
  },
  {
    gradeLevel: "Grade 2",
    tuition: "35,948",
    misc: "10,477",
    books: "4,500",
    total: "50,926",
    subsidy: "",
    grandTotal: "50,926",
  },
  {
    gradeLevel: "Grade 3",
    tuition: "36,764",
    misc: "12,026",
    books: "5,000",
    total: "53,790",
    subsidy: "",
    grandTotal: "53,790",
  },
  {
    gradeLevel: "Grade 4",
    tuition: "37,610",
    misc: "15,585",
    books: "5,000",
    total: "58,194",
    subsidy: "",
    grandTotal: "58,194",
  },
  {
    gradeLevel: "Grade 5",
    tuition: "38,045",
    misc: "15,634",
    books: "5,000",
    total: "58,679",
    subsidy: "",
    grandTotal: "58,679",
  },
  {
    gradeLevel: "Grade 6",
    tuition: "38,045",
    misc: "18,634",
    books: "5,000",
    total: "61,679",
    subsidy: "",
    grandTotal: "61,679",
  },
  {
    gradeLevel: "Grade 7",
    tuition: "41,851",
    misc: "15,976",
    books: "5,000",
    total: "62,827",
    subsidy: "9,000",
    grandTotal: "53,827",
  },
  {
    gradeLevel: "Grade 8",
    tuition: "41,851",
    misc: "15,976",
    books: "5,000",
    total: "62,827",
    subsidy: "9,000",
    grandTotal: "53,827",
  },
  {
    gradeLevel: "Grade 9",
    tuition: "43,754",
    misc: "16,383",
    books: "5,000",
    total: "65,137",
    subsidy: "9,000",
    grandTotal: "56,137",
  },
  {
    gradeLevel: "Grade 10",
    tuition: "43,754",
    misc: "20,348",
    books: "5,000",
    total: "69,102",
    subsidy: "9,000",
    grandTotal: "60,102",
  },
  {
    gradeLevel: "Grade 11",
    tuition: "34,452",
    misc: "14,494",
    books: "",
    total: "48,946",
    subsidy: "14,000",
    grandTotal: "34,946",
  },
  {
    gradeLevel: "Grade 12",
    tuition: "34,452",
    misc: "20,494",
    books: "",
    total: "54,946",
    subsidy: "14,000",
    grandTotal: "40,946",
  },
];

exports.tuitionFeeSched = [
  {
    id: 1,
    gradeLevel: "Nursery",
    cash: "37,856",
    uponEnrollmentSemi: "20,578",
    semi: "17,578",
    uponEnrollmentQuarterly: "11,839",
    quarterly: "8,839",
    monthly: " 2,886",
    uponEnrollmentMonthlyPlusBooks: "7,000 + 3,000",
    uponEnrollmentMonthly: "7,000",
    withSHSVoucher: false,
  },
  {
    id: 2,
    gradeLevel: "Pre-Kinder",
    cash: "39,440",
    uponEnrollmentSemi: "21,370",
    semi: "18,370",
    uponEnrollmentQuarterly: "12,235",
    quarterly: "9,235",
    monthly: "3,044",
    uponEnrollmentMonthlyPlusBooks: "7,000 + 3,000",
    uponEnrollmentMonthly: "7,000",
    withSHSVoucher: false,
  },
  {
    id: 3,
    gradeLevel: "Kinder",
    cash: "42,840",
    uponEnrollmentSemi: "23,070",
    semi: "20,070",
    uponEnrollmentQuarterly: "14,585",
    quarterly: "10,085",
    monthly: "3,384",
    uponEnrollmentMonthlyPlusBooks: "7,000 + 3,000",
    uponEnrollmentMonthly: "7,000",
    withSHSVoucher: false,
  },
  {
    id: 4,
    gradeLevel: "Grade 1",
    cash: "50,926",
    uponEnrollmentSemi: "27,863",
    semi: "23,363",
    uponEnrollmentQuarterly: "16,231",
    quarterly: "11,731",
    monthly: "4,043",
    uponEnrollmentMonthlyPlusBooks: "7,000 + 4,500",
    uponEnrollmentMonthly: "7,000",
    withSHSVoucher: false,
  },
  {
    id: 5,
    gradeLevel: "Grade 2",
    cash: "50,926",
    uponEnrollmentSemi: "27,863",
    semi: "23,363",
    uponEnrollmentQuarterly: "16,231",
    quarterly: "11,731",
    monthly: "4,043",
    uponEnrollmentMonthlyPlusBooks: "7,000 + 4,500",
    uponEnrollmentMonthly: "7,000",
    withSHSVoucher: false,
  },
  {
    id: 6,
    gradeLevel: "Grade 3",
    cash: "53,790",
    uponEnrollmentSemi: "29,545",
    semi: "24,545",
    uponEnrollmentQuarterly: "17,323",
    quarterly: "12,323",
    monthly: "4,279",
    uponEnrollmentMonthlyPlusBooks: "7,000 + 5,000",
    uponEnrollmentMonthly: "7,000",
    withSHSVoucher: false,
  },
  {
    id: 7,
    gradeLevel: "Grade 4",
    cash: "58,194",
    uponEnrollmentSemi: "31,747",
    semi: "26,747",
    uponEnrollmentQuarterly: "18,424",
    quarterly: "13,424",
    monthly: "4,719",
    uponEnrollmentMonthlyPlusBooks: "7,000 + 5,000",
    uponEnrollmentMonthly: "7,000",
    withSHSVoucher: false,
  },
  {
    id: 8,
    gradeLevel: "Grade 5",
    cash: "58,679",
    uponEnrollmentSemi: "31,990",
    semi: "26,990",
    uponEnrollmentQuarterly: "18,545",
    quarterly: "13,545",
    monthly: "4,768",
    uponEnrollmentMonthlyPlusBooks: "7,000 + 5,000",
    uponEnrollmentMonthly: "7,000",
    withSHSVoucher: false,
  },
  {
    id: 9,
    gradeLevel: "Grade 6",
    cash: "61,679",
    uponEnrollmentSemi: "33,490",
    semi: "28,490",
    uponEnrollmentQuarterly: "19,295",
    quarterly: "14,295",
    monthly: " 5,068",
    uponEnrollmentMonthlyPlusBooks: "7,000 + 5,000",
    uponEnrollmentMonthly: "7,000",
    withSHSVoucher: false,
  },
  {
    id: 10,
    gradeLevel: "Grade 7",
    cash: "62,827",
    uponEnrollmentSemi: "34,063",
    semi: "29,063",
    uponEnrollmentQuarterly: "19,582",
    quarterly: "14,582",
    monthly: " 5,183",
    uponEnrollmentMonthlyPlusBooks: "7,000 + 5,000",
    uponEnrollmentMonthly: "7,000",
    withSHSVoucher: false,
  },
  {
    id: 11,
    gradeLevel: "Grade 8",
    cash: "62,827",
    uponEnrollmentSemi: "34,063",
    semi: "29,063",
    uponEnrollmentQuarterly: "19,582",
    quarterly: "14,582",
    monthly: " 5,183",
    uponEnrollmentMonthlyPlusBooks: "7,000 + 5,000",
    uponEnrollmentMonthly: "7,000",
    withSHSVoucher: false,
  },
  {
    id: 12,
    gradeLevel: "Grade 9",
    cash: "65,137",
    uponEnrollmentSemi: "35,218",
    semi: "30,218",
    uponEnrollmentQuarterly: "20,159",
    quarterly: "15,159",
    monthly: "5,414",
    uponEnrollmentMonthlyPlusBooks: "7,000 + 5,000",
    uponEnrollmentMonthly: "7,000",
    withSHSVoucher: false,
  },
  {
    id: 13,
    gradeLevel: "Grade 10",
    cash: "69,102",
    uponEnrollmentSemi: "37,201",
    semi: "32,201",
    uponEnrollmentQuarterly: "21,150",
    quarterly: "16,150",
    monthly: "5,810",
    uponEnrollmentMonthlyPlusBooks: "7,000 + 5,000",
    uponEnrollmentMonthly: "7,000",
    withSHSVoucher: false,
  },
  // { id: 14, gradeLevel: 'Grade 11', cash: ' 34,946', uponEnrollmentSemi: '17,623', semi: '17,623', uponEnrollmentQuarterly: '8,861', quarterly: '8,861', monthly: '2,895', uponEnrollmentMonthly: '7,000', withSHSVoucher: true},
  // { id: 15, gradeLevel: 'Grade 12', cash: '40,946', uponEnrollmentSemi: '20,623', semi: '20,623', uponEnrollmentQuarterly: '10,361', quarterly: '10,361', monthly: '3,495', uponEnrollmentMonthly: '7,000', withSHSVoucher: true},
  {
    id: 16,
    gradeLevel: "Grade 11",
    cash: "48,946",
    uponEnrollmentSemi: "24,623",
    semi: "24,623",
    uponEnrollmentQuarterly: "12,361",
    quarterly: "12,361",
    monthly: "4,295",
    uponEnrollmentMonthlyPlusBooks: "7,000",
    uponEnrollmentMonthly: "7,000",
    withSHSVoucher: false,
  },
  {
    id: 17,
    gradeLevel: "Grade 12",
    cash: "54,946",
    uponEnrollmentSemi: "27,623",
    semi: "27,623",
    uponEnrollmentQuarterly: "13,861",
    quarterly: "13,861",
    monthly: "4,895",
    uponEnrollmentMonthlyPlusBooks: "7,000",
    uponEnrollmentMonthly: "7,000",
    withSHSVoucher: false,
  },
];
